"use strict";

export default class VideoLoader {
  constructor($selector, selfInit = true, config) {
    this.$selector = $selector;
    if (selfInit) this.init();
  }

  init() {
    $("video", this.$selector).on("ended paused", (e) => {
      console.log("video stopped");
      this.$selector.fadeOut(300, () => {
        console.log("video overlay removed");
      });
    });
  }
}
